import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { DialogBody, DialogDescription, DialogHeader, DialogTitle } from '@/components/core/dialog';
import { FormDialogContent } from '@/components/forms/form-dialog';
import { TextareaFormField } from '@/components/forms/textarea-form-field';
import { Result } from '@/shared/helpers/Result';

const schema = z.object({
  reason: z.string().trim().min(1, 'Reason is required'),
});

type Props = {
  onApply: (reason: string) => Promise<Result>;
};

// Mirrors the bill HoldDialogContent: applying an account billing hold is a
// command that requires a mandatory free-text reason.
export function BillingHoldDialogContent({ onApply }: Props) {
  const form = useForm({
    resolver: zodResolver(schema),
    defaultValues: { reason: '' },
  });

  return (
    <FormDialogContent
      form={form}
      submitLabel="Apply hold"
      // Return the Result so the dialog stays open (and the typed reason is
      // preserved) if the command fails.
      onSubmit={(data) => onApply(data.reason)}
    >
      <DialogHeader>
        <DialogTitle>Apply billing hold</DialogTitle>
        <DialogDescription>
          While this account is on billing hold, every new bill created for it is automatically
          held. Existing bills are unaffected.
        </DialogDescription>
      </DialogHeader>
      <DialogBody>
        <TextareaFormField
          control={form.control}
          name="reason"
          label="Reason"
          placeholder="Reason for placing this account on billing hold"
        />
      </DialogBody>
    </FormDialogContent>
  );
}
